module.exports = __webpack_public_path__ + "mobile/img/icon_amount_record.9fdf7f09.png";